import { Divider } from '../../../ui/Divider/Divider';
import { ReportFooterProps } from './ReportFooter.types';

export function ReportFooter({ componentInfo }: ReportFooterProps) {
  return (
    <div className="flex flex-col gap-5 border border-gray-100 rounded-lg p-4">
      <div className="flex flex-col gap-4 text-center">
        <p className="text-xs leading-5 text-gray-900">{componentInfo.text}</p>
        <p className="text-xs leading-5 text-gray-900">
          For compliance inquiries, contact:{' '}
          <a className="underline-custom" href="mailto:">
            {componentInfo.email}
          </a>
        </p>
      </div>
      <Divider classes="-mb-2" />
      <div className="flex items-center justify-center">
        <p className="text-xs leading-5 text-gray-900 mb-1 md:mb-0">
          {componentInfo.generatedBy || 'Generated by CompliAI by SHG'}
        </p>
      </div>
    </div>
  );
}
